// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-image {
  height: 175px;
  width: 175px;
  align-items: center;
  margin: auto;
  margin-left: 20px;
}

.login-form {
  box-shadow: 0 0 230px black;
  padding: 20px;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  display: table-cell;
  vertical-align: middle;
  background-color: #e4e4e4;
  border-radius: 10px;
  border: 3px solid black;
  border-color: #262932 !important;
}

.username-field {
  text-align: center;
  margin-bottom: 25px;
  margin-left: 25px;
  margin-right: 25px;
  border-radius: 10px;
  border: 2px solid black;
  border-color: #262932 !important;
  height: 25px;
  background-color: #262932;
  color: white;
}

.password-field {
  text-align: center;
  margin-bottom: 25px;
  margin-left: 25px;
  margin-right: 25px;
  border-radius: 10px;
  border: 2px solid black;
  border-color: #262932 !important;
  height: 25px;
  background-color: #262932;
  color: white;
}

.username-label {
  text-align: center;
  color: white;
  margin-top: 25px;
  margin-bottom: 25px;
  margin-left: 75px;
  margin-right: 25px;
}

.password-label {
  color: white;
  margin-bottom: 25px;
  margin-left: 80px;
  margin-right: 25px;
}

.login-button {
  margin-bottom: 25px;
  margin-top: 25px;
  margin-left: 40px;
  z-index: 1000000;
  border-radius: 100px;
  background-color: #525a6c !important;
  border-color: #424546 !important;
  color: #ffffff !important;
  font-weight: 500;
  border-width: 2px;
  font-style: normal;
  letter-spacing: 1px;
  /* margin: 0.4rem 0.8rem; */
  white-space: normal;
  transition: all 0.3s ease-in-out;
  padding: 1rem 3rem;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  font-family: 'Rubik', sans-serif;
  font-size: 1rem;
}

/* .repoLabelContainer {
  text-shadow:
    0 0 1px black,
    0 0 1px white;
} */

.login-button:hover {
  color: #ffffff !important;
  background-color: #363a46 !important;
  border-color: #363a46 !important;
}
`, "",{"version":3,"sources":["webpack://./src/login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EAGE,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EAGnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":[".logo-image {\n  height: 175px;\n  width: 175px;\n  align-items: center;\n  margin: auto;\n  margin-left: 20px;\n}\n\n.login-form {\n  -moz-box-shadow: 0 0 130px black;\n  -webkit-box-shadow: 0 0 130px black;\n  box-shadow: 0 0 230px black;\n  padding: 20px;\n  left: 50%;\n  top: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  display: table-cell;\n  vertical-align: middle;\n  background-color: #e4e4e4;\n  border-radius: 10px;\n  border: 3px solid black;\n  border-color: #262932 !important;\n}\n\n.username-field {\n  text-align: center;\n  margin-bottom: 25px;\n  margin-left: 25px;\n  margin-right: 25px;\n  border-radius: 10px;\n  border: 2px solid black;\n  border-color: #262932 !important;\n  height: 25px;\n  background-color: #262932;\n  color: white;\n}\n\n.password-field {\n  text-align: center;\n  margin-bottom: 25px;\n  margin-left: 25px;\n  margin-right: 25px;\n  border-radius: 10px;\n  border: 2px solid black;\n  border-color: #262932 !important;\n  height: 25px;\n  background-color: #262932;\n  color: white;\n}\n\n.username-label {\n  text-align: center;\n  color: white;\n  margin-top: 25px;\n  margin-bottom: 25px;\n  margin-left: 75px;\n  margin-right: 25px;\n}\n\n.password-label {\n  color: white;\n  margin-bottom: 25px;\n  margin-left: 80px;\n  margin-right: 25px;\n}\n\n.login-button {\n  margin-bottom: 25px;\n  margin-top: 25px;\n  margin-left: 40px;\n  z-index: 1000000;\n  border-radius: 100px;\n  background-color: #525a6c !important;\n  border-color: #424546 !important;\n  color: #ffffff !important;\n  font-weight: 500;\n  border-width: 2px;\n  font-style: normal;\n  letter-spacing: 1px;\n  /* margin: 0.4rem 0.8rem; */\n  white-space: normal;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  padding: 1rem 3rem;\n  border-radius: 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  word-break: break-word;\n  font-family: 'Rubik', sans-serif;\n  font-size: 1rem;\n}\n\n/* .repoLabelContainer {\n  text-shadow:\n    0 0 1px black,\n    0 0 1px white;\n} */\n\n.login-button:hover {\n  color: #ffffff !important;\n  background-color: #363a46 !important;\n  border-color: #363a46 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
